module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-room"
  }, [_c('div', {
    staticClass: "room-header"
  }, [_c('button', {
    staticClass: "back-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('back')
      }
    }
  }, [_vm._v("←")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activeRoom && _vm.activeRoom.name))])]), _vm._v(" "), _c('div', {
    ref: "messagesContainer",
    staticClass: "messages-container",
    on: {
      "&scroll": function($event) {
        return _vm.onScroll.apply(null, arguments)
      }
    }
  }, [_vm._l((_vm.displayItems), function(item) {
    return [(item && item.__type === 'date') ? _c('div', {
      key: 'd-' + item.key,
      staticClass: "day-separator"
    }, [_c('span', [_vm._v(_vm._s(item.label))])]) : _c('chat-message', {
      key: item && item.id != null ? 'm-' + item.id : 'm-' + item._key,
      attrs: {
        "message": item
      }
    })]
  })], 2), _vm._v(" "), _c('chat-input', {
    attrs: {
      "room-id": _vm.roomId
    },
    on: {
      "send": _vm.onSend
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e092048","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/chat-plugin/components/ChatRoom.vue
// module id = 1802
// module chunks = 18